module.exports = __webpack_public_path__ + "img/zhifubao-pay.a7e8a169.svg";